export default __webpack_public_path__ + "static/media/Animals-13.451004c9.png";